import agentsJson from '../agents.json';
import RootStore from '../../../../Core/mobx/RootStore';

export const getAgentSignature = () => {
    const agentEmail = RootStore.agentPortalStore.parameterStore?.agent;
    const agent = agentsJson.find((agent) => agent.email === agentEmail);

    return agent
        ? `
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">${agent?.firstName} ${agent?.lastName}</span>
    </p>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">${agent?.directLine}</span>
    </p>
    <p
        style="margin: 0; color: #000000; font-size: 11pt; font-family: 'Arial'; padding-top: 0pt; padding-bottom: 0pt; line-height: 1.15; orphans: 2; widows: 2; text-align: left;">
        <span
            style="color: #000000; font-weight: 400; text-decoration: none; vertical-align: baseline; font-size: 11pt; font-family: 'Arial'; font-style: normal;">[Agent
            Meeting Link]</span>
    </p>`
        : '';
};
